module.exports = __webpack_public_path__ + "static/media/the-mighty-thor-vol1.b70faf5a.jpg";